import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const PhoneComputerIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_phonecomputerillustration_svg_a)"
      d="m90.808 134.85 29.966-4.752-57.618-28.688-29.93 4.787z"
      opacity={0.6}
    />
    <path
      fill="#020203"
      d="M60.773 33.51v64.873l101.322-18.199V15.381c0-2.077-1.892-3.66-3.925-3.309l-92.701 15.84a5.69 5.69 0 0 0-4.696 5.597"
    />
    <path
      fill="#8E8E8E"
      d="M154.525 10.946 63.927 26.328c-3.365.599-5.783 3.52-5.783 6.935v61.459c0 1.443.841 2.78 2.138 3.45l.526.246V33.544a5.73 5.73 0 0 1 4.696-5.632l93.577-15.91-1.121-.563a5.5 5.5 0 0 0-3.435-.493M114.606 125.346 60.808 98.418v1.76c0 1.056.595 2.042 1.542 2.499l53.167 26.506c1.822.915 3.89 1.197 5.923.845l94.664-16.967c1.191-.211 2.067-1.267 2.067-2.499v-1.373l-95.785 17.283c-2.663.458-5.397.071-7.78-1.126"
    />
    <path
      fill="#C9C9C9"
      d="m122.421 126.437 95.47-17.177a.55.55 0 0 0 .14-1.021L161.85 80.184 60.738 98.383l53.728 26.893c2.488 1.232 5.292 1.654 7.955 1.161"
    />
    <path
      fill="#fff"
      d="M63.296 32.559v61.037c0 .563.49.95 1.051.88l94.243-17.002a1.21 1.21 0 0 0 1.017-1.197V16.085a1.25 1.25 0 0 0-1.472-1.232L64.733 30.904c-.841.106-1.437.81-1.437 1.655"
    />
    <path
      fill="#3B3A3A"
      d="m99.92 112.357 86.603-15.945c.211-.036.281-.352.07-.458l-24.708-12.355a2.25 2.25 0 0 0-1.507-.211L73.845 99.333c-.21.035-.28.352-.07.458l24.674 12.355c.42.246.946.317 1.472.211"
    />
    <path
      fill="#BABABA"
      d="m155.226 116.863 27.512-5.069c.421-.07.526-.669.105-.88l-15.245-7.603c-1.157-.563-2.454-.775-3.715-.528l-27.478 5.069c-.42.07-.525.668-.105.88l15.211 7.603a6.15 6.15 0 0 0 3.715.528"
    />
    <path
      fill="#FDCF0C"
      d="M63.296 32.559v4.646l96.276-16.966V16.05a1.25 1.25 0 0 0-1.472-1.232L64.698 30.869a1.7 1.7 0 0 0-1.402 1.69"
    />
    <path
      fill="#D41116"
      d="m67.992 34.354 2.208-.387-.14.14-2.068.458zM67.992 34.073l2.419-.458-.105.14-2.314.458zM67.992 34.67l1.963-.351-.105.14-1.858.353zM84.325 31.397l-2.208.458.105-.212 2.103-.387zM84.325 31.714l-2.419.493.105-.212 2.314-.422zM82.467 31.327l1.858-.352v.14l-1.963.388zM70.095 34.424l1.017-1.584 1.261-.246c.14 0 .14 0 .035.14l-.245.388c0 .035-.105.14.105.106l1.752-.352c-.35.528-.84.88-1.471 1.02zM76.124 32.559l-.561.81-1.472.316.526-.88zM78.297 32.101l-.596.845-1.507.282.595-.845zM78.787 31.996l-.14.246c-.21.282 0 .528.596.458l2.418-.458.596-.845c-.035-.035-3.47.599-3.47.599"
    />
    <path
      fill="#D41116"
      d="m70.831 32.066-.525.774 2.838-.528c.14 0 .14 0 .036.141l-.246.387c0 .036-.105.141.105.106l1.192-.211.35-.528c.21-.352 0-.88-.736-.74zM78.437 31.89l-3.68.74.98-1.514 1.508-.282-.56.88.665-.14.56-.916 1.508-.246zM81.486 30.024l-1.017 1.479-1.577.352.982-1.514z"
    />
    <path
      fill="#EFEEEE"
      d="M69.184 43.928v1.584c0 .81.7 1.408 1.507 1.232l81.766-15.382a1.54 1.54 0 0 0 1.262-1.514v-2.006c0-.81-.701-1.408-1.507-1.232L70.796 41.992c-.946.212-1.612 1.021-1.612 1.936"
    />
    <path
      fill="#F6F6F6"
      d="M69.184 51.884v8.025c0 .81.7 1.408 1.507 1.232l81.766-15.382a1.54 1.54 0 0 0 1.262-1.514v-8.448c0-.81-.701-1.408-1.507-1.232L70.796 49.948a1.96 1.96 0 0 0-1.612 1.936"
    />
    <path
      fill="#020203"
      d="m158.17 12.072-92.701 15.84a5.69 5.69 0 0 0-4.661 5.597v64.874L162.13 80.184V15.381c-.035-2.112-1.927-3.696-3.96-3.309m1.402 64.17c0 .598-.421 1.091-1.017 1.197L64.312 94.44c-.525.106-1.051-.316-1.051-.88V32.56c0-.845.596-1.549 1.402-1.69l93.402-16.051a1.25 1.25 0 0 1 1.472 1.232v60.192z"
    />
    <path
      fill="#EFEFEF"
      d="M69.184 66.21v17.389c0 .81.7 1.408 1.507 1.232l26.075-4.823a1.54 1.54 0 0 0 1.262-1.513V60.683c0-.81-.7-1.407-1.507-1.231l-25.76 4.857a1.95 1.95 0 0 0-1.577 1.9"
    />
    <path
      fill="#F4F3F4"
      d="M101.182 60.226v17.389c0 .81.701 1.408 1.507 1.232l49.768-9.293a1.54 1.54 0 0 0 1.262-1.514V50.23c0-.81-.701-1.409-1.507-1.233l-49.417 9.293c-.947.211-1.613.986-1.613 1.936"
    />
    <path
      fill="url(#dhl__illustrations_phonecomputerillustration_svg_b)"
      d="m25.307 133.178 22.11-4.297-6.483-3.14-22.11 4.297z"
      opacity={0.5}
    />
    <path
      fill="#3A3A3A"
      d="m43.76 127.229 31.585-5.619c1.662-.331 2.826-1.818 2.826-3.471l1.663-60.651c-.832-2.479-3.492-3.801-7.149-2.975l-28.593 5.123c-1.829.33-3.325 2.149-3.325 3.967v61.643s0 2.809 1.829 3.47c.665.331 1.662.331 2.493.331"
    />
    <path
      fill="#000"
      d="m77.174 123.428-31.586 5.619c-1.662.33-2.826-.827-2.826-2.314V65.09c0-1.653 1.33-3.14 2.826-3.47L77.174 56c1.662-.33 2.826.827 2.826 2.314v61.643c0 1.653-1.164 3.306-2.826 3.471"
    />
    <path fill="#EFEFEF" d="m77.673 116.156-32.417 5.95-.166-53.215 32.417-5.784z" />
    <path fill="#1FC696" d="m55.23 120.288-9.974 1.818V96.49l9.974-1.653z" />
    <path fill="#FCCE09" d="m77.507 68.726-32.417 5.95V68.89l32.417-5.784z" />
    <path fill="#fff" d="m77.506 93.846-32.25 5.784v-3.14l32.25-5.95z" />
    <path fill="#fff" d="m58.223 119.627-2.993.661V95.333l2.993-.496zM71.023 95.003l-2.992.496V70.544l2.826-.496z" />
    <path fill="#008CFF" d="m61.38 95.994-16.124 2.81v-1.488l16.125-2.974z" />
    <path
      fill="#D40511"
      d="M61.381 82.608c-2.66.495-4.987 3.14-4.987 5.784s4.987 7.602 4.987 7.602 4.987-6.61 4.987-9.255c0-2.81-2.327-4.627-4.987-4.131m0 6.94c-1.164.166-1.995-.495-1.995-1.652s.998-2.148 1.995-2.479c1.164-.165 1.995.496 1.995 1.653s-.831 2.314-1.995 2.479"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_phonecomputerillustration_svg_a"
        x1={73.789}
        x2={81.519}
        y1={125.032}
        y2={108.575}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopColor="#020203" stopOpacity={0} />
        <stop offset={0.599} stopColor="#020203" stopOpacity={0.3} />
        <stop offset={1} stopColor="#020203" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_phonecomputerillustration_svg_b"
        x1={30.192}
        x2={31.632}
        y1={130.63}
        y2={126.069}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.25} stopOpacity={0} />
        <stop offset={0.599} stopOpacity={0.3} />
        <stop offset={1} stopOpacity={0.8} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
